import React from "react";

const Payment = () => {
  return (
    <div className="col-md-11 mx-auto">
      <img
        src="https://images2.imgbox.com/68/8d/P0Fsg5gZ_o.png"
        alt="payment"
        width="100%"
      />
    </div>
  );
};

export default Payment;
